import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { SlClose } from "react-icons/sl";

import { useDispatch, useSelector } from "react-redux";
import { fetchGalleryData } from "../../redux/slicer/gallerySlice";

function AlbumGallery() {
  const dispatch = useDispatch();
  const {
    data: galleryData,
    loading: galleryLoading,
    error: galleryError,
  } = useSelector((state) => state.gallery.gallery);

  useEffect(() => {
    dispatch(fetchGalleryData());
  }, [dispatch]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAlbum, setSelectedAlbum] = useState(null);
  const sliderRef = useRef(null);  // Add a ref for the slider

  const openModal = (album) => {
    setSelectedAlbum(album);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedAlbum(null);
  };

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: (
      <div className="absolute top-1/2 -left-4 transform -translate-y-1/2 z-10 cursor-pointer bg-white p-2 rounded-full shadow-lg md:-left-8">
        <FaChevronLeft size={20} />
      </div>
    ),
    nextArrow: (
      <div className="absolute top-1/2 -right-4 transform -translate-y-1/2 z-10 cursor-pointer bg-white p-2 rounded-full shadow-lg md:-right-8">
        <FaChevronRight size={20} />
      </div>
    ),
    afterChange: (current) => {
      // Update thumbnail active state here if needed
    },
  };


  const goToSlide = (index) => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(index);
    }
  };


  if (galleryLoading) {
    return <div>Loading...</div>;
  }

  if (galleryError) {
    return <div>Error: {galleryError}</div>;
  }
  return (
    <div className="container mx-auto p-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {galleryData.map((album) => (
          <div
            key={album.album_id}
            className="shadow-lg rounded-lg bg-white cursor-pointer"
            onClick={() => openModal(album)}
          >
            <img
              src={album.images[0]?.image_url}
              alt={album.album_name}
              className="rounded-t-lg w-full h-48 object-cover"
            />
            <div className="p-4">
              <h2 className="font-bold text-lg mb-2 font-titillium">
                {album.album_name}
              </h2>
              <button
                onClick={(e) => {
                  e.stopPropagation(); // Prevent album click
                  openModal(album);
                }}
                className="text-primary-color font-semibold hover:underline"
              >
                View Album
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Popup Modal */}
      {isModalOpen && selectedAlbum && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80 z-50">
          <div className="relative max-w-5xl w-full bg-black rounded-lg shadow-lg m-4">
            {/* Top-Right Close Button */}
            <button
              className="absolute -top-5 -right-1 text-red-600 text-4xl hover:text-gray-300 z-50"
              onClick={closeModal}
              style={{ marginTop: "-20px" }}
            >
              <IoIosCloseCircleOutline />
            </button>

            {/* Slider */}
            <Slider {...sliderSettings} ref={sliderRef}>
              {selectedAlbum.images.map((image) => (
                <div key={image.image_id} className="flex justify-center items-center">
                  <img
                    src={image.image_url}
                    alt={`Thumbnail ${image.image_id}`}
                    className="w-full max-h-[60vh] object-contain rounded-lg"  // Adjusted height for responsiveness
                  />
                </div>
              ))}
            </Slider>

            {/* Thumbnails */}
            <div className="flex justify-center mt-4 space-x-2 overflow-x-auto p-2">
              {selectedAlbum.images.map((image, index) => (
                <div key={image.image_id} className="flex justify-center items-center">
                  <img
                    src={image.image_url}
                    alt={`Thumbnail ${image.image_id}`}
                    className="w-16 h-16 object-cover rounded cursor-pointer border-2 border-transparent hover:border-white"
                    onClick={() => goToSlide(index)}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AlbumGallery;